/* Compras de la fuente existente. Sin fechas aleatorias ni HTML del proveedor. */
(function () {
  'use strict';
  var container = document.getElementById('sales-pop');
  if (!container || container.dataset.miMounted) return;
  container.dataset.miMounted = '1';
  // El viewport, no una sección transformada del tema, es la referencia del flotante.
  document.body.append(container);
  var endpoint = 'https://sales-pop-millennio.digitdeckshop.workers.dev/orders';
  var orders = [], index = 0, shown = 0, dismissed = false;
  var nextTimer = null, hideTimer = null, loaded = false;

  function text(value, max) {
    return typeof value === 'string' ? value.trim().slice(0, max) : '';
  }
  function imageURL(value) {
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && /(^|\.)shopify\.com$/.test(url.hostname) ? url.href : '';
    } catch (error) { return ''; }
  }
  function normalise(order) {
    if (!order || typeof order !== 'object') return null;
    var name = text(order.name, 100).split(/\s+/)[0];
    var product = text(order.product, 240);
    if (!name || !product) return null;
    return { name: name, city: text(order.city, 80), product: product,
      handle: /^[a-z0-9][a-z0-9-]*$/i.test(order.handle || '') ? order.handle : '',
      image: imageURL(order.image) };
  }
  function overlayOpen() {
    if (document.querySelector('html.m2a,html.m6pn-open,html.f8fl-open,' +
      '.mi-buscador.esta-montado,#mi-vdr:not([hidden]),.mi-recogida.esta-montado,' +
      'html[data-mi-discount-manual-open]')) return true;
    return Array.from(document.querySelectorAll('#omnisend-forms-wrapper [role="dialog"]'))
      .some(function (dialog) { return dialog.getClientRects().length && dialog.getBoundingClientRect().height > 0; });
  }
  function hide() {
    window.clearTimeout(hideTimer);
    hideTimer = null;
    container.hidden = true;
    container.replaceChildren();
  }
  function schedule(delay) {
    window.clearTimeout(nextTimer);
    nextTimer = null;
    if (dismissed || !loaded || !orders.length || shown >= 8 || document.hidden) return;
    nextTimer = window.setTimeout(show, delay);
  }
  function show() {
    nextTimer = null;
    if (dismissed || document.hidden || shown >= 8 || !orders.length) return;
    if (overlayOpen()) { schedule(10000); return; }
    var order = orders[index++ % orders.length];
    var toast = document.createElement('div');
    toast.className = 'sp-toast';
    if (order.image) {
      var image = document.createElement('img');
      image.className = 'sp-toast-img';
      image.src = order.image;
      image.alt = '';
      image.width = image.height = 54;
      image.decoding = 'async';
      image.addEventListener('error', function () { image.remove(); }, { once: true });
      toast.append(image);
    }
    var body = document.createElement('div');
    body.className = 'sp-toast-body';
    var buyer = document.createElement('div');
    var name = document.createElement('span');
    name.className = 'sp-toast-name';
    name.textContent = order.name;
    buyer.append(name);
    if (order.city) buyer.append(document.createTextNode(' de ' + order.city));
    buyer.title = buyer.textContent;
    var purchase = document.createElement('div');
    purchase.append(document.createTextNode('compró '));
    var product = document.createElement(order.handle ? 'a' : 'span');
    product.textContent = order.product;
    product.title = order.product;
    if (order.handle) product.href = '/products/' + order.handle;
    purchase.append(product);
    var caption = document.createElement('div');
    caption.className = 'sp-toast-time';
    // La fuente expone un ts de registro, no una fecha de pedido verificada.
    // No se presenta una compra histórica como si acabara de suceder.
    caption.textContent = 'Compra registrada';
    body.append(buyer, purchase, caption);
    var close = document.createElement('button');
    close.className = 'sp-toast-close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Cerrar aviso de compra');
    close.textContent = '×';
    close.addEventListener('click', function () {
      dismissed = true;
      window.clearTimeout(nextTimer);
      hide();
    });
    toast.append(body, close);
    container.replaceChildren(toast);
    container.hidden = false;
    shown++;
    hideTimer = window.setTimeout(function () {
      // No retirar un enlace o cierre mientras el cliente lo usa con teclado.
      if (container.contains(document.activeElement)) return;
      hide();
      schedule(25000);
    }, 6000);
    toast.addEventListener('focusout', function (event) {
      if (container.contains(event.relatedTarget)) return;
      hide();
      schedule(25000);
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      window.clearTimeout(nextTimer);
      nextTimer = null;
      hide();
    } else schedule(4000);
  });
  function load() {
    fetch(endpoint, { credentials: 'omit', referrerPolicy: 'no-referrer' })
      .then(function (response) { if (!response.ok) throw new Error('sales-pop'); return response.json(); })
      .then(function (data) {
        if (!Array.isArray(data)) return;
        orders = data.slice(0, 40).map(normalise).filter(Boolean);
        loaded = true;
        schedule(4000);
      }).catch(function () { /* Sin fuente disponible, no fabricar avisos. */ });
  }
  if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 6000 });
  else window.setTimeout(load, 2000);
})();
